module.exports = __webpack_public_path__ + "static/media/icon-savings.7c86e400.7c86e400.png";